import axios from "axios";
import { uiAction } from "../store/ui-gemini";
import { useDispatch } from "react-redux";

export function configAxiosDefault() {
  const axiosService = axios;

  axiosService.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err?.response?.status === 401) {
        const path = window.location?.pathname || "";
        const requiresAuth = path.startsWith("/home") || path.startsWith("/admin") || path.startsWith("/subs");
        if (requiresAuth) {
          window.location.href = "/login";
          return;
        }
        // On public routes, don't hard-redirect. Let callers handle it.
        return Promise.reject(err);
      } else if (err?.response?.status === 403 && !err?.response?.data?.key) {
        window.location.href = "/home";
      } else {
        return Promise.reject(err);
      }
    }
  );

  const axiosDefault = axiosService.defaults;
  axiosDefault.baseURL = process.env.REACT_APP_SERVER_ENDPOINT;

  axiosDefault.withCredentials = true;
  axiosDefault.headers.common["Content-Type"] = "application/json";

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  axiosDefault.headers.common["Time-Zone"] = timeZone;
  return axiosService;
}
